import React from 'react'

function NoDataFound({message = "No data available to display."}) {
  return (
    <div style={{ display: "flex", alignItems: "start", width: "100%", flexDirection : 'column', gap: 5 }}>
        <div style={{display : "flex", alignItems : "center", flexDirection : 'row', gap : 5}}>
            <img
                src={require("../../assets/house.png")}
                style={{ width: 40, height: 40 }}
            />
            <label style={{fontSize : 12, fontStyle : 'italic', color : 'rgba(0,0,0,0.5)'}}>No data available to display. </label>
        </div>
        <label style={{fontSize : 12, fontStyle : 'italic', color : 'rgba(0,0,0,0.5)'}}>{message}</label>
    </div>
  )
}

export default NoDataFound